/**
 * React component for rendering a customized legend for a weatherNet graph.
 * @param {Object} props - The props object containing color, datasetName, isPavementTemp.
 * @returns {JSX.Element} - The JSX element representing the graph legend.
 */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import WeatherForecastLegend from '@components/WeatherForecast/WeatherForecastLegend';
import { RISK_CODE_COLOURS, WEATHERNET_PAVEMENT } from '@awp/constants';
import { selectMultiStationData, selectObservationTypes, selectData } from '@awp/stores/dataVisualizationSlice';
import { isValueEmpty } from '@awp/helpers/utilsReact';

const WeatherForecastLegends = (props) => {
  const { type } = props;
  const allObservationTypes = useSelector(selectObservationTypes);
  const otTempForecasted = allObservationTypes.find(
    (o) => (o.ObservationTypeName + '').toLocaleLowerCase() === 'surfacetemp',
  );
  const tempForecastedColor =
    !otTempForecasted || isValueEmpty(otTempForecasted.DefaultGraphColor)
      ? WEATHERNET_PAVEMENT.TEMP_FORECASTED_HSL
      : otTempForecasted.DefaultGraphColor;
  const legendWidth = 12;
  return type === 'conidtion' ? (
    <>
      <Row>
        <Col lg={legendWidth} md={legendWidth} className="container-transition legend-transition multiwx-legend">
          <WeatherForecastLegend color={RISK_CODE_COLOURS[0]} datasetName={'Measured Normal'} />
        </Col>
      </Row>
      <Row>
        <Col lg={legendWidth} md={legendWidth} className="container-transition legend-transition multiwx-legend">
          <WeatherForecastLegend color={RISK_CODE_COLOURS[1]} datasetName={'Measured Grip Warning'} />
        </Col>
      </Row>
      <Row>
        <Col lg={legendWidth} md={legendWidth} className="container-transition legend-transition multiwx-legend">
          <WeatherForecastLegend color={RISK_CODE_COLOURS[2]} datasetName={'Measured Grip Alarm'} />
        </Col>
      </Row>
      <Row>
        <Col lg={legendWidth} md={legendWidth} className="container-transition legend-transition multiwx-legend">
          <WeatherForecastLegend color={WEATHERNET_PAVEMENT.STATUS_FORECASTED_HSL} datasetName={'Forecasted'} />
        </Col>
      </Row>
    </>
  ) : (
    <>
      <Row>
        <Col lg={legendWidth} md={legendWidth} className="container-transition legend-transition multiwx-legend">
          <WeatherForecastLegend
            color={WEATHERNET_PAVEMENT.TEMP_MEASURED_HSL}
            datasetName={'Measured'}
            isPavementTemp={true}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={legendWidth} md={legendWidth} className="container-transition legend-transition multiwx-legend">
          <WeatherForecastLegend color={tempForecastedColor} datasetName={'Forecasted'} isPavementTemp={true} />
        </Col>
      </Row>
      <Row>
        <Col lg={legendWidth} md={legendWidth} className="container-transition legend-transition multiwx-legend">
          <WeatherForecastLegend color={''} datasetName={''} isPavementTemp={true} />
        </Col>
      </Row>
      <Row>
        <Col lg={legendWidth} md={legendWidth} className="container-transition legend-transition multiwx-legend">
          <WeatherForecastLegend color={''} datasetName={''} isPavementTemp={true} />
        </Col>
      </Row>
    </>
  );
};

export default WeatherForecastLegends;
